import SubPub from '../utilities/subpub';
import debounce from '../utilities/debounce';

/**
 * --------------------------------------------------------------------------------------------
 * PRIVATE VARIABLES
 * --------------------------------------------------------------------------------------------
 */

const PubSub = new SubPub();

const state = {
  listeningToScroll : false,
  listeningToResize : false,
}

let lastRecordedScroll = 0;



/**
 * --------------------------------------------------------------------------------------------
 * PRIVATE FUNCTIONS
 * --------------------------------------------------------------------------------------------
 */

const resizeHandler = function () {
  // SUB/PUB RESIZE
  var resizeObject = {};
  App.$window.on('resize', function() {
    resizeObject = {
      winWidth: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
      winHeight: Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
    };

    PubSub.publish('EVENT_RESIZE_INSTANT', resizeObject);
  });

  App.$window.on('resize', debounce(function() {
    PubSub.publish('EVENT_RESIZE', resizeObject);
  }, 300));
};


const scrollHandler = function () {
  // SUB/PUB SCROLL
  var scrollObject = {};
  App.$window.on('scroll', function() {
    let bodyOffset = document.body.getBoundingClientRect();
    scrollObject = {
      scrollY: -bodyOffset.top,
      scrollX: bodyOffset.top.left
    };
    PubSub.publish('EVENT_SCROLL_INSTANT', scrollObject);
  });

  App.$window.on('scroll', debounce(function() {
    PubSub.publish('EVENT_SCROLL', scrollObject);
  }, 100));
};



/**
 * --------------------------------------------------------------------------------------------
 * EXPORTS
 * --------------------------------------------------------------------------------------------
 */

export function onScroll (callback) {

  PubSub.subscribe('EVENT_SCROLL_INSTANT', callback);

  if ( !state.listeningToScroll ) {
    scrollHandler();
    state.listeningToScroll = true;
  }
}


export function onResizeDebounced (callback) {

  PubSub.subscribe('EVENT_RESIZE', callback);

  if ( !state.listeningToResize ) {
    resizeHandler();
    state.listeningToResize = true;
  }
}


export function disableScroll () {
  let bodyBounds = document.body.getBoundingClientRect();
  lastRecordedScroll = -bodyBounds.top;
  App.$body.css({
    'position' : 'fixed',
    'top' : -lastRecordedScroll
  });
}


export function enableScroll () {
  App.$body.css({
    'position' : '',
    'top' : ''
  });
  window.scrollTo(0, lastRecordedScroll);
}


export function toggleOverlay () {
    if (!App.$overlay.classList.contains('is-active')) {
        App.$overlay.classList.add('is-active');
        disableScroll();
        setTimeout(() => {
            App.$overlay.classList.add('is-visible');
        }, 350);
    } else {
        App.$overlay.classList.remove('is-visible');
        enableScroll();
        setTimeout(() => {
            App.$overlay.classList.remove('is-active')
        }, 350);
    }
}


export function togglePreloader () {
    if (!App.$preloader.classList.contains('is-active')) {
        App.$preloader.classList.add('is-active');
        disableScroll();
        setTimeout(() => {
            App.$preloader.classList.add('is-visible');
        }, 350);
    } else {
        App.$preloader.classList.remove('is-visible');
        enableScroll();
        setTimeout(() => {
            App.$preloader.classList.remove('is-active')
        }, 350);
    }
}
